import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { UnifiedDashboardComponent } from './shared/components/unified-dashboard/unified-dashboard.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminGuard } from './core/guards/admin.guard';
import { allRolesGuard, doctorNurseGuard } from './core/guards/multi-role.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./components/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },

  // Dashboard unifié pour tous les rôles - chargé directement pour éviter les problèmes de chunk
  {
    path: 'dashboard',
    component: UnifiedDashboardComponent,
    canActivate: [allRolesGuard],
    data: { breadcrumb: 'Dashboard' },
  },

  // Routes principales accessibles selon les permissions
  {
    path: 'schedule',
    loadChildren: () =>
      import('./components/schedule/schedule.routes').then((m) => m.scheduleRoutes),
    canActivate: [allRolesGuard],
    data: { breadcrumb: 'Schedule' },
  },
  {
    path: 'patients',
    loadChildren: () => import('./modules/patients/patients.routes').then((m) => m.patientsRoutes),
    canActivate: [allRolesGuard],
    data: { breadcrumb: 'Patients' },
  },
  {
    path: 'pending-approvals',
    loadComponent: () =>
      import('./components/schedule/pending-approvals/pending-approvals.component').then(
        (m) => m.PendingApprovalsComponent
      ),
    canActivate: [doctorNurseGuard],
    data: { breadcrumb: 'Pending Approvals' },
  },
  {
    path: 'service-tickets',
    loadChildren: () =>
      import('./components/service-tickets/service-tickets.routes').then(
        (m) => m.serviceTicketsRoutes
      ),
    canActivate: [allRolesGuard],
    data: { breadcrumb: 'Service Tickets' },
  },

  // Routes d'administration (admin seulement)
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.routes').then((m) => m.adminRoutes),
    canActivate: [AdminGuard],
    data: { breadcrumb: 'Admin' },
  },
  {
    path: 'construction',
    loadComponent: () =>
      import('./components/construction/construction.component').then(
        (m) => m.ConstructionComponent
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'pharmacy',
    loadChildren: () => import('./modules/pharmacy/pharmacy.routes').then((m) => m.pharmacyRoutes),
    canActivate: [allRolesGuard],
  },

  // Wildcard route - should be last
  { path: '**', redirectTo: '/login' },
];
